import { colorPalette } from './palette/colorPalette'
import { typographyHeadings } from './palette/typographyHeadings'
import { typographyBody } from './palette/typographyBody'

/** MUI palette, typography, and shape — SF Pro, 13 body (Apple Footnote), 1.4 LH, 10 radius */
export const themeOptions = {
  palette: colorPalette,
  typography: {
    fontFamily: 'var(--app-font-sans)',
    htmlFontSize: 16,
    fontSize: 13,
    ...typographyHeadings,
    ...typographyBody,
  },
  shape: {
    borderRadius: 10,
  },
}

export default themeOptions
